import React, { useEffect } from 'react'
import styled from 'styled-components'
import IconPlanProcessOne from '../../images/redesign/plan_process_one.svg'
import IconPlanProcessTwo from '../../images/redesign/plan_process_two.svg'
import IconPlanProcessTree from '../../images/redesign/plan_process_tree.svg'

export default function SelectPlanPhase(props: {
  phase: number
  isSelectSamplePostRoom: boolean
}) {
  const { phase, isSelectSamplePostRoom } = props

  useEffect(() => {}, [])

  return (
    <PlanProcess>
      <div className="plan-process-inner">
        <div className="plan-process-title-box">
          {isSelectSamplePostRoom && <h1>記事の続きが読めるプランはこちら</h1>}
          <h2 className="plan-process-title">
            {phase === 0 && '参加するプランを選んでください'}
            {phase === 1 && '参加するプランを確認してください'}
          </h2>
          <p className="plan-process-lead">
            複数のプランに参加する場合は、
            <br className="tb-only" />
            1プランずつ参加してください
          </p>
        </div>
        <div className="plan-process-process-box">
          <ul className="plan-process-list">
            <li
              className={`plan-process-list-item ${
                phase === 0 ? 'is-active' : ''
              }`}
            >
              <div className="plan-process-number">
                <img
                  src={IconPlanProcessOne}
                  className="plan-process-number-image"
                  alt="1"
                />
              </div>
              <p className="plan-process-process-text">プランを選択</p>
            </li>
            <div className="plan-process-bar"></div>
            <li
              className={`plan-process-list-item ${
                phase === 1 ? 'is-active' : ''
              }`}
            >
              <div className="plan-process-number">
                <img
                  src={IconPlanProcessTwo}
                  className="plan-process-number-image"
                  alt="2"
                />
              </div>
              <p className="plan-process-process-text">プランを確認</p>
            </li>
            <div className="plan-process-bar"></div>
            <li
              className={`plan-process-list-item ${
                phase === 2 ? 'is-active' : ''
              }`}
            >
              <div className="plan-process-number">
                <img
                  src={IconPlanProcessTree}
                  className="plan-process-number-image"
                  alt="3"
                />
              </div>
              <p className="plan-process-process-text">参加完了</p>
            </li>
          </ul>
        </div>
      </div>
    </PlanProcess>
  )
}

const PlanProcess = styled.section`
  background-color: #f6f7f7;
  padding: 50px 20px 84px;
  @media (max-width: 768px) {
    padding: 32px 20px 84px;
    max-width: 100vw;
  }
  .plan-process-inner {
    max-width: 1280px;
    margin: auto;
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
      display: block;
    }
  }
  .plan-process-title-box {
    @media (max-width: 768px) {
      text-align: center;
    }
  }
  .plan-process-title {
    font-size: 16px;
    font-weight: bold;
  }
  .plan-process-lead {
    font-size: 14px;
    font-weight: normal;
    @media (max-width: 768px) {
      font-size: 13px;
      margin-top: 12px;
    }
  }
  .plan-process-process-box {
    max-width: 480px;
    width: 100%;
    @media (max-width: 768px) {
      max-width: 100%;
    }
  }
  .plan-process-list {
    display: flex;
    justify-content: space-between;
    @media (max-width: 768px) {
      margin-top: 24px;
    }
  }
  .plan-process-list-item {
    text-align: center;
    position: relative;
    width: 78px;
    &.is-active {
      .plan-process-number {
        background-color: #26bfdb;
      }
      .plan-process-process-text {
        color: #333;
      }
    }
  }
  .plan-process-bar {
    width: 100px;
    background-color: #dae3e3;
    height: 4px;
    border-radius: 2px;
    position: relative;
    top: 16px;
  }
  .plan-process-number {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    margin: auto;
    background-color: #dae3e3;
    border-radius: 18px;
    font-family: 'Oswald';
    color: #ffffff;
    font-weight: bold;
    text-align: center;
  }
  .plan-process-process-text {
    white-space: nowrap;
    font-size: 13px;
    font-weight: bold;
    color: #dae3e3;
    @media (max-width: 768px) {
      font-size: 11px;
    }
  }
  .plan-process-number-image {
    height: 13px;
  }
`
